export const getRepairServices = state => state.repair;



// WEBPACK FOOTER //
// ./src/store/reducers/repair/selectors.js